import React, { Component } from 'react';

class MidiDocumentation extends Component {
    render() {
        return (
            <div>
              <p>
                To configure MIDI devices, go to the <b>Preferences View</b> by
                clicking the view dropdown at the top right of the screen and
                selecting “Preferences”. 
              </p>
              <p className="sub-header">
                Inputs
              </p>
              <p>
                Each MIDI device connected shows up under inputs, with the following options:
                <ul>
                  <li>
                    <b>Track</b>: Controls whether a MIDI interface can trigger
                    tracks.
                  </li>
                  <li>
                    <b>Sync</b>: Controls whether a MIDI interface can sync the timing. For
                    example, if you press PLAY on a drum machine with SYNC enabled, the
                    sequencer would then play.
                  </li>
                  <li>
                    <b>Keys</b>: Controls whether a MIDI interface is a keyboard. 
                  </li>
                  <li>
                    <b>Pads</b>: Controls whether a MIDI interface is a drum pad.
                  </li>
                </ul>
              </p>
              <p className="sub-header">
                Outputs
              </p>
              <p>
                Each MIDI device connected shows up under outputs, with the following options:
                <ul>
                  <li>
                    <b>Track</b>: Controls whether you can send triggers to a MIDI device.
                  </li>
                  <li>
                    <b>Synced</b>: Controls whether you can send timing data to a MIDI device,
                    including PLAY/STOP events.
                  </li>
                </ul>
              </p>
            </div>
        );
    }
}

export default MidiDocumentation;

